import { getLocalStorageItem, setLocalStorageItem } from 'app/api/localStorage'
import { AnalysisMetadata } from '../types'

const ANALYSIS_JOBS_KEY = 'analysisJobsKey'

export function getAllAnalysis() {
  return getLocalStorageItem(ANALYSIS_JOBS_KEY) || {}
}

export function getAnalysisForMap(mapId: string) {
  const analysisJobs = getAllAnalysis()
  return analysisJobs[mapId] || {}
}

export function getArrayAnalysisFromMap(
  mapId: string
): { connection: string; jobId: string; metadata: AnalysisMetadata }[] {
  return Object.values(getAnalysisForMap(mapId))
}

export function getAnalysis(
  mapId: string,
  jobId: string
): { connection: string; jobId: string; metadata: AnalysisMetadata } {
  return getAnalysisForMap(mapId)[jobId]
}

export function addAnalysis(
  mapId: string,
  analysisMetadata: { connection: string; jobId: string; metadata: AnalysisMetadata }
) {
  const analysis = getAllAnalysis()
  const analysisFromMap = getAnalysisForMap(mapId)
  analysisFromMap[analysisMetadata.jobId] = analysisMetadata
  analysis[mapId] = analysisFromMap
  setLocalStorageItem(ANALYSIS_JOBS_KEY, analysis)
}

export function deleteAnalysis(mapId: string, jobId: string) {
  const analysis = getAllAnalysis()
  const analysisFromMap = getAnalysisForMap(mapId)
  delete analysisFromMap[jobId]
  analysis[mapId] = analysisFromMap
  setLocalStorageItem(ANALYSIS_JOBS_KEY, analysis)
}
